<template>
    <div>
        <div class="messageWrap">
            <div class="headBox">
                <p class="mainTitle">メッセージ</p>
                <div class="blockSearch">
                <label for="search" class="text">メッセージ検索</label>
                <div class="formSearch">
                    <input class="search" type="text" id="search" name="search" v-model="keyword"
                        v-on:keyup.enter="searchStart" />
                    <span class="submit" @click="searchStart()"></span>
                </div>
                </div>
            </div>

            <div class="messageWrap2" id="jsViewMessage">
                <p :class="[this.btnShowMore ? 'button9 jsBtnMore show' : 'button9 jsBtnMore']" @click="showMore()"><span class="jsNumMore" hidden>{{ this.count }}</span>{{ this.count }} コメント</p>
                <div ref="jsViewMessage" class="messageGroup" id="parentId">
                    <div v-for="(message, index) in this.messages" :key="index" :class="[message.show ? 'messageBlock jsBlock show' : 'messageBlock jsBlock', message.showStyle1 ? 'style1' : '']">
                        <div class="blockInfo">
                            <div class="info">
                                <figure class="avatar">
                                    <img v-if="message.from == 1"
                                        v-bind:src="getUserAvatar(message.user_expert.avatar)" :alt="message.user_expert.first_name +' '+ message.user_expert.last_name">
                                    <img v-else
                                        v-bind:src="getUserAvatar(message.user_order.avatar)" :alt="message.user_order.first_name +' '+ message.user_order.last_name">
                                </figure>

                                <p class="txtName">
                                    <div v-if="message.from == 1">
                                        {{ message.user_expert.first_name }} {{ message.user_expert.last_name }}
                                    </div>
                                    <div v-else>
                                        {{ message.user_order.first_name }} {{ message.user_order.last_name }}
                                        ({{ message.user_order.company_order.company_name }})
                                    </div>
                                </p>
                            </div>
                            <p class="txtDate">{{ converCreated(message.created_at) }}</p>

                        </div>
                        <div class="content">
                            <div v-html="formattedContent(message.content)"></div>
                            <div v-if="message.files != null" class="fromButton right mt10">
                                        <a  class="button3" :href="message.files" download>{{ getNameFile(message.files) }}</a>
                            </div>
                        </div>
                    </div>
                    <div v-for="(message, index) in this.messagesAdd" :key="index" class="messageBlock jsBlock show">
                        <div class="blockInfo">
                            <div class="info">
                                <figure class="avatar">
                                    <img v-if="message.from == 1"
                                        v-bind:src="getUserAvatar(message.user_expert.avatar)" :alt="message.user_expert.first_name +' '+ message.user_expert.last_name">
                                    <img v-else
                                        v-bind:src="getUserAvatar(message.user_order.avatar)" :alt="message.user_order.first_name +' '+ message.user_order.last_name">
                                </figure>

                                <p class="txtName">
                                    <div v-if="message.from == 1">
                                        {{ message.user_expert.first_name }} {{ message.user_expert.last_name }}
                                    </div>
                                    <div v-else>
                                        {{ message.user_order.first_name }} {{ message.user_order.last_name }}
                                        ({{ message.user_order.company_order.company_name }})
                                    </div>
                                </p>
                            </div>
                            <p class="txtDate">{{ converCreated(message.created_at) }}</p>
                        </div>
                        <div class="content">
                            <div v-html="formattedContent(message.content)"></div>
                            <div v-if="message.files != null" class="fromButton mt10 right">
                                        <a  class="button3" :href="message.files" download>{{ getNameFile(message.files) }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p v-if="messageFail" class="txtCommon07 mt5">
                {{ messageFail }}
            </p>

            <div class="messageInput" v-if="showMessageInput !=0">
                <div class="headCap">
                    <div class="fromButton">
                        <label class="button3" for="file1">
                            <div v-if="files == ''">
                                ファイルを選択する
                            </div>
                            <div v-else>
                                {{ this.files.name }}
                            </div>
                        </label>
                        <input ref="inputFile" type="file" accept=".zip,.pdf,.xls,.xlsm,.xlsx,.doc,.docx,.png,.jpg,.ppt,.pptx,.PDF,.XLS,.XLSM,.XLSX,.DOC,.DOCX,.PNG,.JPG,.PPT,.PPTX"
                            v-on:change="onFileChange" class="none" id="file1" name="file">
                        <p class="textError">Error Text</p>
                    </div>
                    <button @click="sendMessageDebounce()" class="button8" type="submit">送信</button>
                </div>
                <div class="content">
                    <textarea v-model="message" class="textarea" name="" id="" placeholder="ここにメッセージを入力してください"></textarea>
                </div>
            </div>
            <p v-if="isMessErr" class="mt20 errorTxt">メッセージを入力してください。</p>
        </div>
    </div>
</template>

<script>
import Stomp from 'webstomp-client';
import moment from 'moment';
import Mark from 'mark.js';
import 'moment-timezone';
export default {
    props: {
        userInfo: {
            type: Object
        },
        hostInfo: {
            type: String
        },
        groupId: {
            type: String
        },
        showMessageInput: {
            type:Number
        },
        projectId: {
            type: Number
        },
        statusProposalInfo: {
            type: Number
        },
        statusProjectInfo: {
            type: Number
        },
        messageFail: {
            type:String
        }
    },

    data() {
        return {
            messages      : [],
            messagesAdd   : [],
            message       : '',
            group_id      : '',
            topic         : '',
            files         : '',
            startSend     : 0,
            count         : 0,
            messagesMore  : [],
            btnShowMore   : false,
            searchData    : [],
            keyword       : '',
            bool_search   : false,
            before_keyword: '',
            timeoutId     : null,
            isMessErr     : false,
        }
    },

    created() {
        this.connectServer();
        this.getMessage();
        this.topic = "/topic/chat_" + this.groupId;
    },
    methods: {
        getUserAvatar(avatarUrl) {
            if (avatarUrl == null) {
                return "/assets/img/expert/profile/icon_default.jpg";
            } else {
                return avatarUrl;
            }
        },

        searchStart(event) {
            if(this.keyword == ''){
                this.before_keyword = '';
            }
            if(this.keyword != '' || this.messages.length==0){
                if(this.keyword !=''){
                    this.bool_search    = true;
                    this.before_keyword = this.keyword;
                }else{
                    this.bool_search    = false;
                    this.before_keyword = '';
                }
            let data = {
                search  : this.keyword,
                group_id: this.groupId
            }
            axios
                .post("/chat/get-value-search", data)
                .then(response => {
                    let result = response.data
                    if (result.status == true) {
                        this.messages     = [...this.messagesAdd, ...this.messages]
                        this.messagesAdd  = [];
                        this.messages     = result.data.search;
                        this.messagesMore = result.data.messagesMore;
                        this.showMessagesSearch(result.data.count);
                    }
                });
            }
        },

        showMessagesSearch(count) {
            const countMess  = this.messages.length;
                  this.count = count - countMess;
            if (count > countMess) {
                this.btnShowMore = true;
            } else {
                this.btnShowMore = false;
            }
            if(countMess==0){
                this.btnShowMore = false;
                this.messages    = [];
                this.messagesAdd = [];
            }
            this.messages.forEach((item, index) => {
                item.showStyle1 = false;
                item.show       = true;
            });

            this.messages = [...this.messagesMore, ...this.messages];
            var lengt_message_more = this.messagesMore.length - 1;
            if(lengt_message_more >= 0){
                this.messages[lengt_message_more].showStyle1 = true;
                this.messages[lengt_message_more].show       = true;
            }
        },

        async getMessage() {
            let data = {
                group_id: this.groupId
            }
            await axios
                .post("/chat/get-message", data)
                .then(response => {
                    let result = response.data
                    if (result.status == true) {
                        this.count    = result.data.count;
                        this.messages = result.data.messages;
                        const countMess     = this.messages.length;
                        this.messages.forEach((item, index) => {
                            if (countMess >= 5) {
                                if (index == (countMess - 1) || index == (countMess - 2) || (index == countMess - 3)) {
                                    item.showStyle1 = false;
                                    item.show       = true;
                                } else if (index == (countMess - 4)) {
                                    item.showStyle1  = true;
                                    item.show        = true;
                                    this.btnShowMore = true;
                                } else {
                                    item.showStyle1 = false;
                                    item.show       = false;
                                }
                                this.count = result.data.count - 3;
                            } else {
                                item.showStyle1 = false;
                                item.show       = true;
                            }
                        });
                    }
                });
        },
        sendMessageDebounce() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId)
            }
            const temp = this
            this.timeoutId = setTimeout(function() {
                temp.sendMessage()
            }, 500)
        },
        sendMessage () {
            if(this.message != '' || this.files != ''){
                this.isMessErr = false;
                let formData = new FormData();
                formData.append('from', this.userInfo.from);
                formData.append('user_id', this.userInfo.id);
                formData.append('group_id', this.groupId);
                formData.append('content', this.message);
                formData.append('files', this.files);
                formData.append('project_id', this.projectId);

                const headers = { 'Content-Type': 'multipart/form-data' };
                axios
                    .post("/chat/send", formData, { headers })
                    .then(response => {
                        let result = response.data;
                        if (result.status == true) {
                            this.message               = '';
                            this.$refs.inputFile.value = '';
                            this.files                 = '';
                            this.client.send(this.topic, JSON.stringify(result.data));
                        }
                    })
                    .catch(error => {
                    })
            } else {
                this.isMessErr = true;
            }
        },

        connectServer() {
            let config                         = JSON.parse(this.hostInfo);
            var socket                         = new WebSocket(`${config.url}`);
                this.client                    = Stomp.over(socket);
                this.client.heartbeat.outgoing = 60000;
                this.client.heartbeat.incoming = 0;
                this.client.hasDebug           = null;
            this.client.connect(config.username, config.password, this.stompSuccessCallback, this.stompFailureCallback);
        },

        stompSuccessCallback() {
            var $this = this
            if (this.topic != '') {
                this.client.subscribe($this.topic, function (message) {
                    var data = JSON.parse(message.body);
                    $this.messagesAdd.push(data)
                    $this.startSend = 1;
                    data            = {
                        group_id: $this.groupId,
                        user_id : $this.userInfo.id,
                        type    : $this.userInfo.from,
                    }
                    axios
                        .post("/chat/check-notification", data)
                        .then(response => {
                            let result = response.data
                        });
                }, { ack: 'client' });

            }
        },

        stompFailureCallback() {
            var $this = this
            setTimeout(function () {
                $this.connectServer()
            }, 5000)
        },

        onFileChange(e) {
            const file              = e.target.files[0];
            const allowedExtensions = [".zip", ".pdf", ".xls", ".xlsm", ".xlsx", ".doc", ".docx", ".png", ".jpg", ".ppt", ".pptx", ".ZIP", ".PDF", ".XLS", ".XLSM", ".XLSX", ".DOC", ".DOCX", ".PNG", ".JPG", ".PPT", ".PPTX"];
            const maxFileSize       = 10 * 1024 * 1024;                                                                                                                                                                          // 20MB
            let   invalidFiles      = [];
            let   validFiles        = [];
            const fileType          = file.type;
            const fileName          = file.name;
            const fileSize          = file.size;

            if (!allowedExtensions.includes(this.getFileExtention(fileName))) {
                invalidFiles.push(fileName);
            } else if (fileSize > maxFileSize) {
                invalidFiles.push(fileName);
            } else {
                validFiles.push(file);
            }

            let formData = new FormData();
            formData.append('file',file);
            const headers = { 'Content-Type': 'multipart/form-data' };
            axios
                .post("/upload/file", formData, { headers })
                .then(response => {
                })
                .catch(error => {
                    invalidFiles.push(fileName);
                    alert(`the following files are invalid: ${invalidFiles.join(", ")}
                        \r\ ".zip", ".pdf", ".xls", ".xlsm", ".xlsx", ".doc", ".docx", ".png", ".jpg", ".ppt", ".pptx" and < = 20MB
                    `);
                    this.files                 = [];
                    this.$refs.inputFile.value = '';
                })

            if (invalidFiles.length > 0) {
                alert(`the following files are invalid: ${invalidFiles.join(", ")}
                \r\ ".zip", ".pdf", ".xls", ".xlsm", ".xlsx", ".doc", ".docx", ".png", ".jpg", ".ppt", ".pptx" and < = 20MB
                `);
                this.$refs.inputFile.value = '';
            } else {
                this.files = e.target.files[0];
            }
        },

        getFileExtention(filename){
            return filename.substring(filename.lastIndexOf('.'), filename.length) || filename;
        },

        openlink(e) {
            window.open(e, '_blank');
        },

        converCreated(data) {
            return moment(data).tz('Asia/Tokyo').format('M月D日 HH:mm')
        },

        getNameFile(data) {
            const fileName = data.substring(data.lastIndexOf("/") + 1);
            return fileName;
        },

        nl2br(text) {
            return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
        e(text) {
            const el = document.createElement('div');
            el.innerText = text;
            return el.innerHTML;
        },

        formattedContent(data) {
            if(this.bool_search){
                const keyword       = this.before_keyword;
                const div           = document.createElement('div');
                const encodedStr    = data.replace(/[\u00A0-\u9999<>\&]/g, i => '&#'+i.charCodeAt(0)+';');
                      div.innerHTML = encodedStr;
                const instance      = new Mark(div);

                instance.mark(keyword, {
                    className         : 'highlighted',
                    separateWordSearch: false
                });
                return div.innerHTML;

            }else{
                return this.nl2br(this.e(data));
            }
        },

        showMore() {
            this.messages.forEach((item, index) => {
                item.showStyle1 = false;
                item.show = true;
            });

            let data = {
                group_id: this.groupId,
                final_message_id: this.messages[0].id,
            }
            axios
                .post("/chat/get-message-next", data)
                .then(response => {
                    let result = response.data
                    if (result.status == true) {
                        this.messagesMore = result.data.messages;
                        this.messages     = [...this.messagesMore, ...this.messages];
                        if (result.data.messages == '') {
                            this.count       = this.count - this.count;
                            this.btnShowMore = false;
                        } else {
                            if(this.count > 20){
                                               this.count                               = this.count - 20;
                                 this.messages[this.messagesMore.length - 1].showStyle1 = true;
                                 this.messages[this.messagesMore.length - 1].show       = true;
                             }else{
                                 this.count       = 0;
                                 this.btnShowMore = false;

                                 const endIndex = Math.min(20, this.messages.length);  // Tính chỉ số kết thúc của vòng lặp
                                 for (let i = 0; i < endIndex; i++) {
                                     this.messages[i].showStyle1 = false;
                                     this.messages[i].show       = true;
                                 }
                             }
                        }
                    }
                });
        }
    },

}
</script>

